function closeGeneralModal(e, modalMessage, modalOverlay) {
  e.preventDefault();
  modalMessage.classList.add("none");
  modalMessage.classList.remove("active");
  modalOverlay.classList.add("hidden");
}

const generalModalMessage = document.querySelector(".general-modal-message");

if (generalModalMessage !== null) {
  const generalModalTriggers = document.querySelectorAll(
    ".general-modal-trigger",
  );
  const generalModalOverlay = document.querySelector(".general-modal-overlay");
  const generalModalClose = document.querySelector(".general-modal-close");
  const generalModalCloseImg = document.querySelector(
    ".general-modal-close img",
  );

  generalModalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      if (
        e.target === generalModalClose ||
        e.target === generalModalCloseImg ||
        e.target.tagName === "A"
      ) {
        return;
      }
      e.preventDefault();
      generalModalMessage.classList.remove("none");
      generalModalMessage.classList.add("active");
      generalModalOverlay.classList.remove("hidden");
    });
  });

  generalModalClose.addEventListener("click", (e) => {
    closeGeneralModal(e, generalModalMessage, generalModalOverlay);
  });

  generalModalOverlay.addEventListener("click", (e) => {
    closeGeneralModal(e, generalModalMessage, generalModalOverlay);
  });
}
